import React, { Component } from "react";
import "./css/privacypolicy.css";
import "./css/styles.css";
class Privacypolicy extends React.Component {
  render() {
    return (
      <div>
        <div
          className="privacy"
          style={{ padding: "20px", paddingTop: "80px" }}
        >
          <div className="container">
            <h3>AiPlex Privacy Policy</h3>
            <p>
              This website is operated by AiPlex, a trading division of the
              AiPlex Software Pvt Ltd.   AiPlex (also referred to as "we" and
              "us") may collect personal data about you when you interact with
              us. As a business, we are committed to respecting and protecting
              the privacy of all individuals with whom we interact. We will
              process your personal data at all times in accordance with
              applicable privacy and data protection laws.
            </p>
            <p>
              This Privacy Notice describes how we collect and use your personal
              information and the rights you have in relation to that
              information. AiPlex is the data controller of any personal data
              you provide to us, including in relation to this website{" "}
              <a href="https://aiplex.com/" target="_blanck">
                https://aiplex.com/
              </a>
            </p>
            <p>This Privacy Notice explains the following:</p>
            <ul>
              <li>Information we may collect</li>
              <li>How we use this information </li>
              <li>How long we will keep your information </li>
              <li>How we secure your information</li>
              <li>Information sharing and disclosure </li>
              <li>International and group company transfers</li>
              <li>Your rights</li>
              <li>Our responsibility for website links</li>
              <li>Updates</li>
              <li>How to contact us</li>
            </ul>
            <p>
              In the <strong>Supplementary Information</strong> section of this
              Privacy Notice, we explain what is meant by 
              <strong>“personal data”</strong> and other terms used in this
              notice.
            </p>
            <p>
              <strong>Information we may collect</strong>
            </p>
            <h2>Technical Information</h2>
            <p>
              We collect information about how you use our website and the
              device(s) you use to access our site. This includes collecting
              unique mobile device ID or the internet protocol (IP) address
              online identifiers, which are numbers that can uniquely identify a
              specific computer or other network device on the internet. 
            </p>
            <h2>Contact data</h2>
            <p>
              We also collect personal data about you if you make use of any of
              the interactive features within our website. For example, when you
              complete a data capture forms on our website, subscribe to our
              newsletters or when you respond to a blog on our website. The
              personal data we collect includes your name, address, job title
              and location. 
            </p>
            <h2>Marketing and Communications data</h2>
            <p>
              We collect information about your preference in receiving
              marketing information from us. 
            </p>
            <h2>Children</h2>
            <p>
              We do not actively seek to collect information about children aged
              16 or under. If you have any concerns about your child’s privacy
              in relation to our services, or if you believe that your child may
              have shared personal data via this website, please contact us at 
              <a href="mailto:tech@aiplex.com;" target="_blanck">
                tech@aiplex.com
              </a>
              We will delete such information from our records with a reasonable
              time.
            </p>
            <h3>How we use this information</h3>
            <p>
              Except where required by law, we only use the personal data you
              provide for the following purposes: 
            </p>
            <ul>
              <li>
                To deliver the specific information or services you have
                requested;
              </li>
              <li>To enable the download of our content</li>
              <li>
                Send you newsletters and information relating to our services
              </li>
              <li>Respond to your requests and feedback.</li>
            </ul>
            <p>
              Under data protection law we are required to advise you on the
              legal basis for processing your personal data. For the most part,
              the processing of your personal data is based either on a) our
              legitimate interests related to us providing you services you have
              requested, or b) your consent, where requested.
            </p>
            <h3>How long we will keep your information</h3>
            <p>
              We will keep your personal data for as long as is necessary for
              the relevant service, in accordance with our legal obligations.
              After this time, your personal data will either be securely
              deleted or anonymized so that it can be used for analytical
              purposes. u may request further information via the contact
              details given in this Privacy Notice.
            </p>
            <h3>How we secure your information</h3>
            <p>
              We maintain appropriate organizational and technological
              safeguards to help protect against unauthorized use, access to or
              accidental loss, alteration or destruction of personal data. We
              also seek to ensure our service providers do the same.
            </p>
            <h3>Information sharing and Disclosure</h3>
            <p>
              Information shared with our third-party service providers We use a
              number of third parties to perform business functions on our
              behalf, such as sending our newsletters and hosting our online
              services. We will only disclose the information necessary to
              enable these third parties to perform their services. Our service
              providers are contracted to comply with our instructions and we
              require that they do not use your personal data for their own
              business purpose.  Information shared with other parties 
            </p>
            <p>
              Where required or permitted by law, personal data may be provided
              to others, such as regulator and law enforcement agencies, for
              example in response to a court order or a subpoena, or in response
              to a law enforcement agency’s request, or where we believe it is
              necessary to investigate, prevent or take action regarding illegal
              activities, and as otherwise required by law. 
            </p>
            <h3>Our responsibility for website links</h3>
            <p>
              This Privacy Notice is limited to the personal information which
              we collect and use via this website. We provide links within this
              site to other websites, including social media sites such as
              Facebook, Twitter and LinkedIn If you follow these links, you
              should use these sites in conjunction with their applicable user
              and privacy notices as their data practices fall outside the scope
              of this Privacy Notice. Further, we can have no responsibility for
              or control over the information collected by any 3rd party website
              and we cannot be responsible for the protection and privacy of any
              information which you may provide on such websites.
            </p>
            <h3>Updates</h3>
            <p>
              This Privacy Notice may be updated from time to time to reflect
              changes in law, best practice or a change in our practices
              regarding the treatment of personal data. The date of the most
              recent revision will appear at the top of this page. If you do not
              agree to the changes, please do not continue to use our services
              and please refrain from sharing your personal data with us. You
              should check this notice frequently for updates. 
            </p>
            <h3>Contact us</h3>
            <p>
              If you have any questions about this Privacy Notice, our approach
              to privacy or you would like to exercise any of the rights
              mentioned in this Privacy Notice you can contact our Data
              Protection Officer in any of the following ways:
            </p>
            <h3>Address:</h3>
            <p>
              #91A, 3rd Floor, Ideal Homes Circle Next to Nimishambha Temple
              Rajarajeshwari Nagar Bengaluru
            </p>
            <p>
              Email:{" "}
              <a href="mailto:tech@aiplex.com;" target="_blanck">
                tech@aiplex.com
              </a>{" "}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default Privacypolicy;
